// src/pages/accessrequest/components/AccessPromo.jsx
export default function AccessPromo() {
    return (
      <div className="hidden md:flex flex-1 bg-blue-900 text-white p-8 flex-col justify-center">
        <h3 className="text-3xl font-bold mb-4">Trade the <span className="underline">Futures</span> Markets</h3>
        <ul className="list-disc pl-6 space-y-2 text-sm text-blue-100">
          <li>$100 Intraday Margins on Micro Indices</li>
          <li>$0.35 Commissions on Micros</li>
          <li>Sign in to open a Futures account in just a few steps!</li>
        </ul>
      </div>
    );
  }
  